// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__J1LZ1","content":"Contact_content__Vw63t","links":"Contact_links__jdYkD","link":"Contact_link__aB+2C"};